module.exports = __webpack_public_path__ + "img/cjlogistics_charge_logo.ab7b1363.png";